var _defs, _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapFax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGDoc",
    width: 22,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Generated with Avocode.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Icon metro-printer"), /*#__PURE__*/React.createElement("path", {
    d: "M14.60976,10.67049h-7.92267v6.60223h7.92267zM4.0462,6.70915c0,-0.72926 -0.59119,-1.32045 -1.32045,-1.32045c-0.72925,0 -1.32044,0.59119 -1.32044,1.32045c0,0.72926 0.59118,1.32045 1.32044,1.32045c0.7293,0 1.32045,-0.59119 1.32045,-1.32045zM19.89153,4.06827c0.72625,0 1.32045,0.59421 1.32045,1.32045v6.60223c0,0.72625 -0.5942,1.32045 -1.32044,1.32045h-3.96133v5.28178h-10.56356v-5.28178h-3.96134c-0.72637,0 -1.32045,-0.5942 -1.32045,-1.32045v-6.60223c0,-0.72625 0.59421,-1.32045 1.32045,-1.32045zM5.36664,0.10693h10.56356v2.64089h-10.56356z",
    fill: "currentColor",
    fillOpacity: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapFax);
export default __webpack_public_path__ + "static/media/map-fax.b61fee41.svg";
export { ForwardRef as ReactComponent };